import Vue from "vue";
import Vuetify from "vuetify/lib";

const light = {
    primary: "#009636",
    primaryLight: "#42CA73",
    secondary: "#005681",
    secondaryLight: "#0D76AB",
    accent: "#3980FF",
    accentLight: "#72C4D6",
    warning: "#F8D239",
    warningLight: "#F2D872",
    error: "#E66946",
    errorLight: "#E5927A",
    orange: "#E66946",
    orangeLight: "#E5927A",
    information: "#005681",
    dark: "#1E2837",
    darkMedium: "#666666",
    grayDark: "#3D495C",
    grayMedium: "#5E6B80",
    gray: "#808DA1",
    grayLight: "#A5B0C0",
    brown: "#795548",
    brownLight: "#7E6558",
    light: "#F2F4F9",
    loading: "#D6D5D5",
}

const dark = {
    primary: "#0ecc5d",
    accent: "#e1e9f2",
    error: "#f14c22",
    warning: "#ffcb0a",
    information: "#58b7fa",
}

const options = {
    icons: {
        iconfont: "mdiSvg", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    },
    theme: {
        themes: {
            light,
            dark
        }
    }
};

export function themeColor(key = String()) {
    const isDarkMode = localStorage.getItem('theme') === 'dark';
    const theme = isDarkMode ? dark : light;
    return String(theme[key] || "");

}

Vue.use(Vuetify);

export default new Vuetify(options);


